module.exports = __webpack_public_path__ + "static/media/as_bt1.d261937c.png";